<template>
  <div class="page new-ticket">
    <header>
      <div @click="back" tabindex="0" @keypress.space="back" class="back-btn"><i class="fa fa-fw fa-chevron-left"></i></div>
      <div class="view-title">{{ 'changePassword' | lang }}</div>
    </header>
    <div>
      <div class="small-form">
        <!-- <div class="floating-label">
          <input v-model="email" placeholder=" " type="text" :class="{ invalid: invalidEmail }" />
          <label>Email</label>
        </div> -->
        <div class="floating-label">
          <input v-model="oldpassword" placeholder=" " :type="showOldPassword ? 'text' : 'password'" class="with-icon-right" :class="{ invalid: !oldpassword }"/>
          <i class="fa fa-fw right" :class="{ 'fa-eye-slash': showOldPassword, 'fa-eye': !showOldPassword }" @click="showOldPassword = !showOldPassword"></i>
          <label>{{ 'CurrentPassword' | lang }}</label>
        </div>
        <div class="floating-label">
          <input v-model="newpassword" placeholder=" " :type="showNewPassword ? 'text' : 'password'" class="with-icon-right" :class="{ invalid: passwordErrors.all }"/>
          <i class="fa fa-fw right" :class="{ 'fa-eye-slash': showNewPassword, 'fa-eye': !showNewPassword }" @click="showNewPassword = !showNewPassword"></i>
          <label>{{ 'NewPassword' | lang }}</label>
        </div>
        <div>
          {{ 'PasswordConditions' | lang }}
          <ul id="password-errors">
            <li :class="{ 'text-green': !passwordErrors.maiuscola, 'text-red': passwordErrors.maiuscola }">
              <i class="fa fa-fw" :class="{ 'fa-check': !passwordErrors.maiuscola, 'fa-exclamation-triangle': passwordErrors.maiuscola }"></i>&nbsp;{{ 'AtLeastAnUpperLetter' | lang }}
            </li>
            <li :class="{ 'text-green': !passwordErrors.minuscola, 'text-red': passwordErrors.minuscola }">
              <i class="fa fa-fw" :class="{ 'fa-check': !passwordErrors.minuscola, 'fa-exclamation-triangle': passwordErrors.minuscola }"></i>&nbsp;{{ 'AtLeastALowerLetter' | lang }}
            </li>
            <li :class="{ 'text-green': !passwordErrors.cifra, 'text-red': passwordErrors.cifra }">
              <i class="fa fa-fw" :class="{ 'fa-check': !passwordErrors.cifra, 'fa-exclamation-triangle': passwordErrors.cifra }"></i>&nbsp;{{ 'AtLeastADigit' | lang }}
            </li>
            <li :class="{ 'text-green': !passwordErrors.simbolo, 'text-red': passwordErrors.simbolo }">
              <i class="fa fa-fw" :class="{ 'fa-check': !passwordErrors.simbolo, 'fa-exclamation-triangle': passwordErrors.simbolo }"></i>&nbsp;{{ 'AtLeastASymbol' | lang }}
            </li>
            <li :class="{ 'text-green': !passwordErrors.lunghezza, 'text-red': passwordErrors.lunghezza }">
              <i class="fa fa-fw" :class="{ 'fa-check': !passwordErrors.lunghezza, 'fa-exclamation-triangle': passwordErrors.lunghezza }"></i>&nbsp;{{ 'AtLeast8chars' | lang }}
            </li>
          </ul>
        </div>
        <div class="floating-label">
          <input v-model="newpassword2" placeholder=" " :type="showNewPassword2 ? 'text' : 'password'" class="with-icon-right" :class="{ invalid: password2Errors.all }"/>
          <i class="fa fa-fw right" :class="{ 'fa-eye-slash': showNewPassword2, 'fa-eye': !showNewPassword2 }" @click="showNewPassword2 = !showNewPassword2"></i>
          <label>{{ 'NewPasswordRepeat' | lang }}</label>
        </div>
        <ul id="password-errors" v-if="newpassword2">
          <li v-if="!password2Errors.match" class="text-green">
            <i class="fa fa-fw fa-check"></i>&nbsp;{{ 'PasswordsMatch' | lang }}
          </li>
          <li v-else class="text-red">
            <i class="fa fa-fw fa-exclamation-triangle"></i>&nbsp;{{ 'PasswordsMismatch' | lang }}
          </li>
        </ul>
        <div v-if="status">
          <div v-if="status === 'waiting'">
            <i class="fa fa-fw fa-refresh fa-spin"></i>{{ 'pleaseWait' | lang }}
          </div>
          <div v-else-if="status === 'error'" class="text-red">
            <i class="fa fa-fw fa-exclamation-triangle"></i>{{ 'errorOccured' | lang }}
          </div>
          <div v-else-if="status === 'success'" class="text-green">
            <i class="fa fa-fw fa-check"></i>{{ 'PasswordUpdated' | lang }}
          </div>
        </div>
      </div>
    </div>
    <footer>
      <button class="full-width" @click="recover" :disabled="invalidForm || isWaiting">{{ 'Confirm' | lang }}</button>
    </footer>
  </div>
</template>

<script>
import page from '@/mixins/routeControl'
import UserServices from '@/mixins/services/userServices'

export default {
  name: 'Account',
  mixins: [ page, UserServices ],
  data () {
    return {
      // email: null,
      oldpassword: '',
      newpassword: '',
      newpassword2: '',
      status: '',
      showOldPassword: false,
      showNewPassword: false,
      showNewPassword2: false
    }
  },
  computed: {
    invalidForm () {
      return /*this.invalidEmail || */this.passwordErrors.all || this.password2Errors.all || !this.oldpassword
    },
    /* invalidEmail () {
      return !this.checkEmailValidity(this.email)
    }, */
    passwordErrors () {
      /* if(/^(?=.*[A-Z])(?=.*[!@#$&*])(?=.*[0-9])(?=.*[a-z]).{8,}$/.test(this.password)) {
        return null
      } */
      let maiuscola = !(/[A-Z]/.test(this.newpassword))
      let minuscola = !(/[a-z]/.test(this.newpassword))
      let simbolo = !(/[!@#$&*.:]/.test(this.newpassword))
      let cifra = !(/[0-9]/.test(this.newpassword))
      let lunghezza = !(/^.{8,}$/.test(this.newpassword))
      return {
        maiuscola, minuscola, simbolo, cifra, lunghezza, all: maiuscola || minuscola || simbolo || cifra || lunghezza
      }
    },
    password2Errors () {
      let match = this.newpassword !== this.newpassword2
      return {
        match, all: match
      }
    },
    isWaiting () {
      return this.status === 'waiting'
    }
  },
  methods: {
    recover () {
      this.showPassword = false
      this.status = 'waiting'
      this._changePassword(localStorage.getItem('login_email'), this.oldpassword, this.newpassword).then(data => {
        this.status = 'success'
        console.log(data)
        setTimeout(() => {
          this.back()
          // this.goTo(this.waitingLoginPage, true, true)
          // this.waitingLoginPage = null
        }, 700)
      }).catch(err => {
        this.status = 'error'
        console.log(err)
      })
    }
  },
  watch: {
    showOldPassword (newV, oldV) {
      if (newV && !oldV) {
        clearTimeout(this.timeoutShowOldPassword)
        this.timeoutShowOldPassword = setTimeout(() => {
          this.showOldPassword = false
        }, 2000)
      }
    },
    showNewPassword (newV, oldV) {
      if (newV && !oldV) {
        clearTimeout(this.timeoutShowNewPassword)
        this.timeoutShowNewPassword = setTimeout(() => {
          this.showNewPassword = false
        }, 2000)
      }
    },
    showNewPassword2 (newV, oldV) {
      if (newV && !oldV) {
        clearTimeout(this.timeoutShowNewPassword2)
        this.timeoutShowNewPassword2 = setTimeout(() => {
          this.showNewPassword2 = false
        }, 2000)
      }
    }
  }
}
</script>

<style></style>
